import PropertyValue from 'automation-ui-flow-core/fields/PropertyValue';
import { Map as ImmutableMap, Record } from 'immutable';
export default class ActionInput extends Record({
  name: null,
  value: new PropertyValue({})
}, 'ActionInput') {
  constructor(props = {}) {
    const propMap = ImmutableMap(props);
    const value = propMap.get('value');
    super(propMap.set('value', new PropertyValue(value)));
  }
  getValue() {
    return this.get('value');
  }
  setValue(value) {
    return this.set('value', value);
  }
  getName() {
    return this.get('name');
  }
  setName(name) {
    return this.set('name', name);
  }
  hasValue() {
    return !!this.getValue().getValue();
  }
  hasName() {
    return !!this.getName();
  }
  isStaticActionInput() {
    return this.getValue().isStaticPropertyValue();
  }
}